














import {Vue, Component, Prop, Emit} from 'nuxt-property-decorator'
import AutocompleteArticle from '@/components/AutocompleteArticle.vue'
import { presentArticleData } from '../helpers'

@Component({
  components: {
    AutocompleteArticle
  },
})
export default class TopStories extends Vue {
  @Prop({type: Object, required: true})
  layout: any

  @Prop({type: Boolean, default: false})
  highlightFields: boolean

  @Emit('update')
  addTopStory (index, article) {
    const topStories = [...this.layout.topStories]
    topStories[index] = presentArticleData(article)
    console.log(topStories[index])
    console.log('hello')
    return  {
      topStories
    }
  }
}
